import { AxiosResponse } from "axios";
import API from "../api";
import { Booking } from "../models/booking";
import { CartonView } from "../models/carton";
import { PdfReport } from "../models/pdf.report";
import { PurchaseOrder } from "../models/purchase.order";
import { Brand } from "../models/brand";

const endpoint = "carton/reports";

const CartonReportService = {
  async generate(
    cartons: CartonView[],
    booking?: Booking,
    purchaseOrder?: PurchaseOrder,
    bookingCartonsTotal?: number
  ): Promise<AxiosResponse<PdfReport>> {
    return await API.post(`/${endpoint}/generate`, {
      cartons,
      booking,
      order: purchaseOrder,
      bookingCartonsTotal,
    });
  },
  async generatePreview(brand?: Brand): Promise<AxiosResponse<PdfReport>> {
    return await API.post(`/${endpoint}/generate/preview`, brand);
  },
};

export default CartonReportService;
